import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import categoriesState from 'desktop/utils/categoriesState';
import Channel from 'desktop/components/Channel';
import Scrollbar from 'desktop/components/Scrollbar';
import Collapsible from 'desktop/components/Collapsible';
import {
  SidebarStyled,
  AllChannels,
  ChannelsWrap,
  StyledButton,
  ContentLoaderStyled,
} from './styles/SidebarStyled';

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollTarget: null,
      scrollTo: { value: 0 },
      forceUpdateScrollBar: { id: 0, state: false },
    };
    this.root = React.createRef();
    this.categoriesRenderState = {};
  }

  onCurrentChannelRef = (ref) => {
    if (ref) {
      this.setState({
        scrollTo: {
          value: ref.offsetTop + ref.parentElement.offsetTop - this.root.current.offsetHeight / 2,
        },
      });
    }
  };

  onToggleCollapsible = (state, id) => {
    const {
      genreExpanded
    } = this.props;
    categoriesState.set(id, state);
    genreExpanded(id, state);
    if (state) {
      this.categoriesRenderState[id] = true;
    }

    this.setState({
      forceUpdateScrollBar: { state, id },
    });
  };

  onAllChannelsClick = () => {
    const { allChannelsUrl } = this.props;
    if (allChannelsUrl) {
      window.location.href = allChannelsUrl;
    }
  };

  getScrollTarget = (target) => {
    if (!this.state.scrollTarget) {
      this.setState({ scrollTarget: target });
    }
  };

  renderSkeletonArr = () => {
    const heightEl = 35;
    const count = window.innerHeight / heightEl;
    const arrElments = [];
    for (let i = 0; i <= count; i++) {
      arrElments.push(
        <ContentLoaderStyled
          key={i}
          height={heightEl}
          width={280}
          speed={2}
          primaryColor="#333333"
          secondaryColor="#333333"
        >
          <rect x="40" y="0" width="117" height="13" />
          <rect x="40" y="20" rx="3" ry="3" width="85" height="10" />
          <rect x="0" y="0" rx="0" ry="0" width="30" height="30" />
        </ContentLoaderStyled>
      );
    }
    return arrElments;
  };

  renderChannelsByGenres = () => {
    const {
      channelsByGenres,
      channelsMap,
      currentChannelAbsoluteId,
      switchChannel,
      activePrograms,
      subscriptionInfoMap,
    } = this.props;
    let result;

    if (channelsByGenres && channelsMap) {
      result = channelsByGenres.map((genre) => {
        const openState =
          categoriesState.get(genre.id) || genre.id === _.get(currentChannelAbsoluteId, 'genreId');
        return (
          <Collapsible
            triggerText={`${genre.title} ${genre.channels.length}`}
            defaultOpen={openState}
            lazyRender
            key={genre.id}
            genreId={genre.id}
            onToggle={this.onToggleCollapsible}
          >
            {openState || this.categoriesRenderState[genre.id] ? (
              <ChannelsWrap>
                {genre.channels.map((channelId) => {
                  const channel = channelsMap[channelId];
                  const isInteractive =
                    channel.type === 'vodChannel' || channel.type === 'dvrChannel';
                  const channelText =
                    _.get(activePrograms[channel.id], 'title') || channel.originalGenre.title;
                  const channelIsHoverLocked = channel.isLocked
                    ? `${this.props.translate('inSubscription')} ${subscriptionInfoMap[
                        channel.subscriptionId
                      ] || ''}`
                    : '';
                  return (
                    <Channel
                      key={channel.id}
                      id={channel.id}
                      img={channel.image}
                      title={channel.title}
                      text={channelText}
                      currentChannelAbsoluteId={currentChannelAbsoluteId}
                      getCurrentChannelRef={this.onCurrentChannelRef}
                      switchChannel={switchChannel}
                      interactive={isInteractive}
                      parentGenreId={genre.id}
                      locked={channel.isLocked}
                      lockedHoverText={channelIsHoverLocked}
                    />
                  );
                })}
              </ChannelsWrap>
            ) : null}
          </Collapsible>
        );
      });
    }

    return result;
  };

  render() {
    const { translate, channelsByGenres, showAllChannelsButton } = this.props;
    const { scrollTo, forceUpdateScrollBar } = this.state;
    return (
      <SidebarStyled ref={this.root}>
        <Scrollbar
          heightRelativeToParent="100%"
          getScrollTarget={this.getScrollTarget}
          scrollTo={scrollTo}
          forceUpdateScrollBar={forceUpdateScrollBar}
        >
          {showAllChannelsButton && (
            <AllChannels>
              <StyledButton
                onClick={this.onAllChannelsClick}
                text={translate('allChannels')}
                textColor="white"
                buttonStyle="transparent"
                textType="uppercase"
                textFont="din_bold"
                icon="channels"
                separation={10}
                iconSize={24}
                fixedTextSize
                spacing={1}
                hoverColor="fire"
              />
            </AllChannels>
          )}
          {channelsByGenres.length === 0 && this.renderSkeletonArr()}
          {channelsByGenres.length > 0 && this.renderChannelsByGenres()}
        </Scrollbar>
      </SidebarStyled>
    );
  }
}

Sidebar.propTypes = {
  currentChannelAbsoluteId: PropTypes.object,
  switchChannel: PropTypes.func,
  translate: PropTypes.func,
  channelsMap: PropTypes.object,
  channelsByGenres: PropTypes.array,
  activePrograms: PropTypes.object,
  subscriptionInfoMap: PropTypes.object,
  showAllChannelsButton: PropTypes.bool,
  allChannelsUrl: PropTypes.string,
};

Sidebar.defaultProps = {
  currentChannelAbsoluteId: null,
  switchChannel: Function.prototype,
  translate: Function.prototype,
  channelsMap: null,
  channelsByGenres: null,
  activePrograms: {},
  subscriptionInfoMap: {},
  showAllChannelsButton: false,
  allChannelsUrl: '',
};

export default Sidebar;
